export const state = {
  currentUser: localStorage.getItem("authUser"),
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue.token;
    window.localStorage.setItem("authUser", newValue.token);

    let dateObj = Date.now();
    dateObj += newValue.expire;
    const newTokenExprieDate = new Date(dateObj)
    window.localStorage.setItem("tokenExpireDate", newTokenExprieDate);
  },
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
};

export const actions = {
  // Logs in the current user.
  logIn({ commit }, { token, expire } = {}) {
    const user = {};
    user.token = token;
    user.expire = expire;

    commit("SET_CURRENT_USER", user);
  },

  // Logs out the current user.
  // eslint-disable-next-line no-unused-vars
  logOut() {
    window.localStorage.removeItem("authUser");
    window.localStorage.removeItem("tokenExpireDate");
    state.currentUser = null;
  },
};
